import { isArray, isNull, isUndefined, isNumber, isBoolean, isString } from 'lodash';
const EMPTY_STRING = '""';

function graphqlify(jsonObject: any): string {
  if (jsonObject) {
    return JSON.stringify(jsonObject)
      .replace(/\"([^(\")"]+)\":/g, '$1:')
      .replace(/(null)/g, EMPTY_STRING);
  }

  return '';
}

function graphqlifyString(str: any): string {
  if (isString(str)) {
    return JSON.stringify(str);
  }

  return EMPTY_STRING;
}

function buildArgs(args: any = {}, initialArgs: string = ''): string {
  return Object.entries(args).reduce((acc: string, [key, value]: [string, any]): string => {
    if (isNull(value) || isUndefined(value)) {
      return acc;
    }

    if (isNumber(value) || isBoolean(value)) {
      return `${acc} ${key}: ${value}`;
    }

    if (isArray(value)) {
      return `${acc} ${key}: ${graphqlify(value)}`;
    }

    return `${acc} ${key}: "${value}"`;
  }, initialArgs);
}

function getCruiseArgs(params: any = {}): any {
  const { departureDate = '', arrivalDate = '' } = params;
  return {
    cruiseDepartureDate: departureDate,
    cruiseArrivalDate: arrivalDate,
  };
}

function buildCruiseArgs(params: any = {}, optionalArguments: any = {}): string {
  const args = { ...optionalArguments, ...getCruiseArgs(params) };
  return buildArgs(args);
}

const CRUISE_RESORT_ID = 'CM2C';

function buildProductArgs(
  productId: string,
  params: any = {},
  optionalArguments: any = {},
): string {
  if (!productId) {
    throw new Error('You must provide a productId');
  }

  let productArg;

  if (productId !== CRUISE_RESORT_ID) {
    productArg = `productId: "${productId}"`;
  } else {
    const { cruiseDepartureDate, cruiseArrivalDate } = getCruiseArgs(params);
    productArg = `productId: "${productId}_${cruiseDepartureDate}_${cruiseArrivalDate}"`;
  }

  return buildArgs(optionalArguments, productArg);
}

export { graphqlify, graphqlifyString, buildProductArgs, buildCruiseArgs, buildArgs };
